var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4201 12.22C20.0101 12.22 19.6701 11.88 19.6701 11.47V8.15002C19.6701 6.91002 18.6601 5.90002 17.4201 5.90002H3.58008C3.17008 5.90002 2.83008 5.56002 2.83008 5.15002C2.83008 4.74002 3.17008 4.40002 3.58008 4.40002H17.4201C19.4901 4.40002 21.1701 6.08002 21.1701 8.15002V11.47C21.1701 11.89 20.8301 12.22 20.4201 12.22Z",
    fill: "#F9FAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74008 9.06998C6.55008 9.06998 6.36008 8.99995 6.21008 8.84995L3.05008 5.68997C2.91008 5.54997 2.83008 5.35994 2.83008 5.15994C2.83008 4.95994 2.91008 4.76998 3.05008 4.62998L6.21008 1.46994C6.50008 1.17994 6.98008 1.17994 7.27008 1.46994C7.56008 1.75994 7.56008 2.24 7.27008 2.53L4.64011 5.15994L7.27008 7.78995C7.56008 8.07995 7.56008 8.55995 7.27008 8.84995C7.12008 8.98995 6.93008 9.06998 6.74008 9.06998Z",
    fill: "#F9FAFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4201 19.59H6.58008C4.51008 19.59 2.83008 17.91 2.83008 15.84V12.52C2.83008 12.11 3.17008 11.77 3.58008 11.77C3.99008 11.77 4.33008 12.11 4.33008 12.52V15.84C4.33008 17.08 5.34008 18.09 6.58008 18.09H20.4201C20.8301 18.09 21.1701 18.43 21.1701 18.84C21.1701 19.25 20.8301 19.59 20.4201 19.59Z",
    fill: "#F9FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2602 22.75C17.0702 22.75 16.8802 22.68 16.7302 22.53C16.4402 22.24 16.4402 21.7599 16.7302 21.4699L19.3602 18.84L16.7302 16.21C16.4402 15.92 16.4402 15.44 16.7302 15.15C17.0202 14.86 17.5002 14.86 17.7902 15.15L20.9502 18.31C21.0902 18.45 21.1702 18.64 21.1702 18.84C21.1702 19.04 21.0902 19.23 20.9502 19.37L17.7902 22.53C17.6502 22.68 17.4602 22.75 17.2602 22.75Z",
    fill: "#F9FAFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.b82e054544a22fcdd3c024695b81634a.svg";
export { ForwardRef as ReactComponent };